(function () {
  'use strict';

  /* ── Announcement bar height CSS variable ──────────────────────────────────
   * Sets --mn-announcement-height on :root so navigation CSS can offset:
   *   - .menu-drawer__navigation-container padding-top (drawer aligns with nav)
   *   - .mn-mobile-search top (search overlays sticky-header, not announcement)
   * Updated on resize and when the announcement bar is dismissed.
   * ─────────────────────────────────────────────────────────────────────── */
  function setAnnouncementHeight() {
    var bar = document.getElementById('Announcement-header');
    var h = (bar && bar.offsetHeight > 0) ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--mn-announcement-height', h + 'px');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setAnnouncementHeight);
  } else {
    setAnnouncementHeight();
  }
  window.addEventListener('resize', setAnnouncementHeight);

  /* Watch for announcement bar dismissal (attribute change or removal from DOM) */
  var announcementBar = document.getElementById('Announcement-header');
  if (announcementBar) {
    new MutationObserver(setAnnouncementHeight).observe(announcementBar, {
      attributes: true, childList: false, subtree: false
    });
    if (announcementBar.parentNode) {
      new MutationObserver(setAnnouncementHeight).observe(announcementBar.parentNode, {
        childList: true
      });
    }
  }

  /* Watch body for shopify-section-header-hidden class (Shopify hides header on scroll) */
  new MutationObserver(setAnnouncementHeight).observe(document.body, {
    attributes: true, attributeFilter: ['class']
  });

  /* ── Drawer open/close body class ─────────────────────────────────────── */
  var drawer = document.querySelector('.mobile-menu-drawer');
  if (drawer) {
    function ensureTabpanelVisible() {
      var drawerTabs = document.querySelector('#menu-drawer automatic-tabs');
      if (!drawerTabs) return;
      var panels = drawerTabs.querySelectorAll('.tabpanel');
      if (!panels.length) return;
      var anyVisible = Array.from(panels).some(function(p) { return !p.hasAttribute('hidden'); });
      if (!anyVisible) {
        // All panels are hidden — show panel 0 and hide the rest directly,
        // bypassing AutomaticTabs in case aria-controls was never set.
        panels.forEach(function(p, i) {
          if (i === 0) {
            p.removeAttribute('hidden');
          } else {
            p.setAttribute('hidden', 'hidden');
          }
        });
        var firstTab = drawerTabs.querySelector('.tablist button');
        if (firstTab) {
          firstTab.setAttribute('aria-selected', 'true');
          firstTab.setAttribute('tabindex', '0');
        }
      }
    }

    var drawerObserver = new MutationObserver(function () {
      if (drawer.hasAttribute('open')) {
        document.body.classList.add('mn-drawer-open');
        ensureTabpanelVisible();
        setTimeout(ensureTabpanelVisible, 50);
        setTimeout(ensureTabpanelVisible, 200);
        setTimeout(ensureTabpanelVisible, 600);
      } else {
        document.body.classList.remove('mn-drawer-open');
      }
    });
    drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }

  /* ── Open Athos search overlay on any search trigger ── */
  function openSearchOverlay() {
    document.dispatchEvent(new CustomEvent('mn:search:open'));
  }

  /* Intercept mousedown on nav search areas — prevents the native input
     from receiving focus before the click event fires. */
  document.addEventListener('mousedown', function (e) {
    if (
      e.target.closest('.mn-search-wrap') ||
      e.target.closest('.mn-drawer-search') ||
      e.target.closest('.mn-mobile-search-bar') ||
      e.target.closest('#mn-mobile-search')
    ) {
      e.preventDefault();
    }
  }, false);

  document.addEventListener('click', function (e) {
    var inStacked       = e.target.closest('.mn-mobile-search-bar .mn-search');
    var inDesktop       = e.target.closest('.mn-search-wrap .mn-search');
    var inDrawer        = e.target.closest('.mn-drawer-search .mn-search');
    var inMobileSearch  = e.target.closest('#mn-mobile-search .mn-search');
    var inHamburgerIcon = e.target.closest('.mn-hamburger-search');
    var inMobileBtn     = e.target.closest('.mn-search-mobile');
    if (inStacked || inDesktop || inDrawer || inMobileSearch || inHamburgerIcon || inMobileBtn) {
      e.preventDefault();
      openSearchOverlay();
    }
  }, false);

  /* ── Rotating search placeholder ──────────────────────────────────────── */
  var config = window.MNNav || {};
  var placeholders = config.placeholders || [];
  if (placeholders.length >= 2) {
    var inputs = document.querySelectorAll('.mn-search__rotating');
    if (inputs.length) {
      var idx = 0;
      setInterval(function () {
        idx = (idx + 1) % placeholders.length;
        inputs.forEach(function (el) {
          if (el !== document.activeElement) {
            el.setAttribute('placeholder', placeholders[idx]);
          }
        });
      }, 3000);
    }
  }
})();

/* ── Country selector: close on outside click ── */
document.addEventListener('click', function(e) {
  var selector = document.getElementById('mn-country-selector');
  if (selector && !selector.contains(e.target)) {
    selector.removeAttribute('open');
  }
});

/* ── Transparent header: solidify past a per-page scroll threshold ── */
(function () {
  var w = document.querySelector('.header-wrapper.mn-headerw--transparent');
  if (!w) return;
  var at = parseInt(w.dataset.solidAt || '200', 10);
  var queued = false;
  function mnSolid() {
    w.classList.toggle('mn-headerw--solid', (window.pageYOffset || document.documentElement.scrollTop || 0) > at);
    queued = false;
  }
  mnSolid();
  window.addEventListener('scroll', function () {
    if (!queued) { queued = true; requestAnimationFrame(mnSolid); }
  }, { passive: true });
})();
